<template>
    <Toast />
    <Dialog v-model:visible="showErrorDialog" modal :header="'Terjadi Kesalahan'" :closable="true"
    class="w-[90vw] md:w-[50vw]">
    <div class="flex items-start space-x-3">
      <ExclamationCircleIcon class="h-6 w-6 text-red-500" />
      <p class="text-gray-700 dark:text-gray-200">{{ errorMessage }}</p>
    </div>
    <template #footer>
      <Button label="Tutup" @click="showErrorDialog = false" severity="secondary" />
    </template>
  </Dialog>
    <IndexView />
    <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ 'hidden': !isBlur }"></div>
    <div class="min-h-screen bg-light-100 dark:bg-dark-700 p-6">
        <!-- Container untuk List Meja dan List Order dalam 2 baris -->
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div class="bg-light-50 dark:bg-dark-800 lg:order-last">
                <CashRegister @showDialog="showModalDialog"/>
            </div>
            <!-- Card List Table -->
            <div class="lg:col-span-2 bg-light-50 dark:bg-dark-800">
                <CardTable @toggleBlur="toggleBlur"/>
            </div>
        </div>
    </div>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import CashRegister from '@/components/card-dashboard/cash-register/CashRegister.vue';
import CardTable from '@/components/card-dashboard/card-table/CardTable.vue';
import { Button, Dialog, Toast } from 'primevue';

export default {
    name: 'DashboardView',
    components: {
        IndexView, CashRegister, CardTable, Dialog, Toast, Button
    },
    data() {
        return {
            showErrorDialog: false,
            errorMessage: '',
            isBlur: false,
            tables: [
                { id: 1, name: 'Table 1', status: 'Available' },
                { id: 2, name: 'Table 2', status: 'Occupied' },
                { id: 3, name: 'Table 3', status: 'Available' },
                { id: 4, name: 'Table 4', status: 'Occupied' },
                { id: 5, name: 'Table 5', status: 'Available' },
            ]
        };
    },
    methods: {
        toggleBlur() {
            this.isBlur = !this.isBlur;
        },
        showModalDialog(errors) {
            this.showErrorDialog = true;
            this.errorMessage = errors;
        }
    }
}
</script>